/**
 * Gets the translated value for an equipment field based on the current language
 * @param {Object} equipment - The equipment object from the database
 * @param {string} field - The field name ('name', 'type', or 'description')
 * @param {string} language - The current language ('en' or 'es')
 * @returns {string} - The translated value or fallback to the original field
 */
export const getEquipmentTranslation = (equipment, field, language) => {
  // If no equipment object, return empty string
  if (!equipment) return '';

  // Try to get the translation for the current language
  const translation = equipment?.translations?.[language]?.[field];

  // If translation exists and is not empty, return it
  if (translation && translation.trim() !== '') {
    return translation;
  }

  // Otherwise, fallback to the original field (which is English for backward compatibility)
  return equipment[field] || '';
};
